import "@/App.css";
import { Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Testimonials from "@/pages/Testimonials";
import CustomiseScope from "@/pages/CustomiseScope";

function App() {
  return (
    <div className="App font-body bg-white text-black min-h-screen antialiased">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/customise-scope" element={<CustomiseScope />} />
      </Routes>
    </div>
  );
}

export default App;
